import React, { useState, useEffect } from 'react';
import Header from '../../layout/Header';
import { Button, Typography, Container, Box, Paper, CircularProgress } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useStyles } from './style';
import DescriptionIcon from '@material-ui/icons/Description';
import LockIcon from '@material-ui/icons/Lock';
import { signEthicsCode, checkEthicsCodeSignature } from '../../services/auth';
import api from '../../services/api';

export function EthicsCode() {
  const classes = useStyles();
  const history = useHistory();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [alreadySigned, setAlreadySigned] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('/documents/CodigoDeEticaV1.pdf'); // Definindo um valor padrão

 useEffect(() => {
  const verifySignatureAndLoadPdf = async () => {
    try {
      // Verifica assinatura
      const signatureResponse = await checkEthicsCodeSignature();
      setAlreadySigned(signatureResponse.jaAssinou);
      
      // Obtém a URL do PDF do backend
      //const response = await api.get('/CodigoDeEtica/obter-pdf-ativo');
       const response = await api.get('/CodigoDeEtica/obter-pdf-ativo', {
          responseType: 'blob' 
        });
        
        // Cria uma URL temporária para o blob
        const fileBlob = new Blob([response.data], { type: 'application/pdf' });
        const fileUrl = URL.createObjectURL(fileBlob);
        setPdfUrl(fileUrl);

      
    } catch (error) {
      console.error('Erro:', error);
      // Fallback para PDF local
      setPdfFile('/documents/CodigoDeEticaV1.pdf');
    } finally {
      setLoading(false);
    }
  };

  verifySignatureAndLoadPdf();
}, [history]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signEthicsCode(password);
      setAlreadySigned(true);
      // Não redirecionamos automaticamente, apenas mostramos mensagem de sucesso
    } catch (err) {
      setError(err.message || 'Senha incorreta ou erro ao assinar o código de ética');
    }
  };

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <Container maxWidth="md" className={classes.root}>
        <Paper elevation={6} className={classes.paper}>
          <Box display="flex" alignItems="center" mb={3}>
            <DescriptionIcon fontSize="large" className={classes.icon} />
            <Typography variant="h4" component="h1">
              Código de Ética
            </Typography>
          </Box>

          <iframe 
            src={pdfUrl}
            className={classes.pdfViewer}
            title="Código de Ética"
          />

          {alreadySigned ? (
            <Box textAlign="center" mt={4} p={3} className={classes.successMessage}>
              <Typography variant="h6" color="primary">
                ✓ Você já assinou o Código de Ética
              </Typography>
              <Box mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => history.push('/app/home')}
                >
                  Voltar para a página inicial
                </Button>
              </Box>
            </Box>
          ) : (
            <form onSubmit={handleSubmit} className={classes.form}>
              <Box mt={4}>
                <Typography variant="body1" gutterBottom>
                  Ao assinar abaixo, você declara que leu e concorda com o Código de Ética da empresa.
                </Typography>
                
                <Box display="flex" alignItems="center" mt={2}>
                  <LockIcon className={classes.lockIcon} />
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Digite sua senha para assinar"
                    className={classes.passwordInput}
                    required
                  />
                </Box>

                {error && (
                  <Typography color="error" className={classes.error}>
                    {error}
                  </Typography>
                )}

                <Box mt={3}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="large"
                    className={classes.submitButton}
                    fullWidth
                  >
                    Assinar Código de Ética
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        </Paper>
      </Container>
    </div>
  );
}